import React from 'react'

import {OfferPrimaryLayoutVariant} from '@vio/core/src/offer/types/OfferLayout'
import {OfferVariant} from '@vio/core/src/offer/types/OfferVariant'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

import {VariantLabel} from '../../Shared/VariantLabel'

interface MainProps {
  anchorPrice: number
  anchorPriceTotal: number
  offer: SearchOffer
  offerVariant: OfferVariant
  variant: OfferPrimaryLayoutVariant
}

export const TagComponent: React.FC<MainProps> = ({
  variant = 'PrimaryDefault',
  anchorPrice,
  anchorPriceTotal,
  offerVariant,
  offer
}) => {
  return (
    <VariantLabel
      hasPadding={variant === 'PrimaryDefault'}
      anchorPrice={anchorPrice}
      anchorPriceTotal={anchorPriceTotal}
      offer={offer}
      variant={offerVariant}
    />
  )
}
